<template>
<div class="container">
  <h1><small>講師詳細</small></h1>
  <div class="section" v-if="item">
    <dl class="dl-info">
      <dt>講師番号</dt>
      <dd>{{ item.lecturer_no }}</dd>
      <dt>メールアドレス</dt>
      <dd>{{ item.email }}</dd>
      <dt>氏名</dt>
      <dd>{{ item.name }}</dd>
      <dt>ふりがな</dt>
      <dd>{{ item.name_kana }}</dd>
      <dt>生年月日（西暦）</dt>
      <dd>{{ item.birthday }}</dd>
      <dt>住所</dt>
      <dd>{{ fullAddress }}</dd>
      <dt>電話番号</dt>
      <dd>{{ item.tel }}</dd>
      <dt>協会ホームページ掲載</dt>
      <dd>{{ item.published ? 'する' : 'しない' }}</dd>
      <dt>講師名（活動名）</dt>
      <dd>{{ item.lecturer_name }}</dd>
      <dt>活動名 ふりがな</dt>
      <dd>{{ item.lecturer_name_kana }}</dd>
      <dt>活動エリア１</dt>
      <dd>{{ item.active_area1 }}</dd>
      <dt>活動エリア２</dt>
      <dd>{{ item.active_area2 }}</dd>
      <dt>取得資格</dt>
      <dd>{{ item.qualification }}</dd>
      <dt>自己紹介</dt>
      <dd class="pre-text">{{ item.introduction }}</dd>
      <dt>始めたきっかけ</dt>
      <dd class="pre-text">{{ item.trigger }}</dd>
      <dt>やってよかったこと</dt>
      <dd class="pre-text">{{ item.good_things }}</dd>
      <dt>ホームページURL</dt>
      <dd>{{ item.homepage }}</dd>
      <dt>FACEBOOKページ</dt>
      <dd>{{ item.facebook }}</dd>
      <dt>LINE@</dt>
      <dd>{{ item.line }}</dd>
      <dt>Instagram</dt>
      <dd>{{ item.instagram }}</dd>
      <dt>ブログ</dt>
      <dd>{{ item.blog }}</dd>
      <dt>撮影会画像</dt>
      <dd>
          <a v-if="item.work_image1" :href="item.work_image1"><img class="col-12 col-sm-5 img-fluid" :src="item.work_image1"></a>
          <a v-if="item.work_image2" :href="item.work_image2"><img class="col-12 col-sm-5 img-fluid" :src="item.work_image2"></a>
      </dd>
    <dt>講師ステータス</dt><dd><lecturer-status :statuses="lecturerStatusText"/></dd>
    <dt>プロフィール写真</dt>
    <dd>
        <a v-if="item.profile_image" :href="item.profile_image"><img class="col-12 col-sm-5 img-fluid" :src="item.profile_image"></a>
    </dd>
    </dl>
  </div>
  <div class="btn-group" role="group" aria-label="group">
    <router-link to="/profile" class="btn btn-outline-info btn-lg">キャンセル</router-link>
    <router-link to="/profile/edit" class="btn btn-secondary btn-lg">変更画面へ</router-link>
  </div>
  <p class="text-right mt-5">
    <router-link to="/mypage">マイページへのリンク</router-link>
  </p>
</div>
</template>

<script>
import LecturerDetail from 'components/LecturerDetail'
import LecturerStatus from 'components/LecturerStatus'
import api from 'api'
import util from 'util/common'
import modal from 'util/modal'
export default {
  components: {
    LecturerDetail,
    LecturerStatus
  },
  created () {
    api.fetchLecturerProfile(this)
    .then(profile => {
      this.item = profile
    }).catch(err => {
      if (err.status === 401) {
        api.onAuthRequired(this)
      } else {
        modal.showErrorModal(this, err)
      }
    })
  },
  computed: {
    fullAddress () {
      return [
        '〒' + this.item.zipcode,
        this.item.prefecture,
        this.item.city,
        this.item.address1,
        this.item.address2
      ].join(' ')
    },
    bank () {
      return this.item.bank || {}
    },
    lecturerStatusText () {
      return util.lecturerStatusesText(this.item.lecturer_statuses)
    }
  },
  data () {
    return {
      item: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// Detail.vue?0d83a599